export default function Settings() {
  return (
    <div className="card">
      <h3>⚙️ Settings</h3>
      <p className="small">Dark mode, refresh interval coming soon.</p>
    </div>
  );
}
